import { combineReducers } from "redux";

import form from "./form.reducer";
import page from "./page.reducer";
import user from "./user.reducer";
import place from "./place.reducer";
import loader from "./loader.reducer";
import extraPanels from "./extraPanels.reducer";
import borrowerInfo from "./borrowerInfo.reducer";
import consoleBrok1 from "./consoleBrok1.reducer";
import resetPassword from "./resetPassword.reducer";

const rootReducer = combineReducers({
  form,
  page,
  loader,
  user,
  borrowerInfo,
  place,
  consoleBrok1,
  extraPanels,
  resetPassword,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer/index.js